export default "__VITE_ASSET__B1KW$PIH__"